<template>
    <svg width="18" height="18" :class="svgClass" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 3.75002V14.25" stroke="black" :class="pathClass" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M3.75 9H14.25" stroke="black" :class="pathClass" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

</template>

<script setup>
    defineProps({
        svgClass: {
            type: String,
            default: 'black'
        },
        pathClass: {
            type: String,
            default: 'black'
        }
    })
</script>